module.exports = __webpack_public_path__ + "static/media/video2019.999ae66b.png";